import { Flex } from "@chakra-ui/react";
import {
  FaGithub, FaHtml5, FaAws, FaVuejs, FaNodeJs, FaJs, FaSass, FaPython,
  FaUbuntu, FaCss3Alt, FaReact, FaJava, FaLaravel, FaDatabase, FaAngular
} from "react-icons/fa";
import {
  SiDotnet, SiDocker, SiCsharp, SiMysql, SiVisualstudiocode, SiAzuredevops,
  SiRabbitmq, SiPostgresql, SiMongodb, SiSpringboot
} from "react-icons/si";
import { RiFlashlightLine, RiCloudLine } from "react-icons/ri"; // Azure Functions & Azure Cloud
import AnimatedIcon from "../../components/AnimatedIcon";

const IconsLine = () => {
  const icons = [
    FaGithub,
    SiCsharp,
    SiAzuredevops,
    SiDocker,
    FaHtml5,
    FaAws,
    SiDotnet,
    SiMysql,
    FaVuejs,
    FaNodeJs,
    FaJs,
    FaSass,
    FaPython,
    FaUbuntu,
    FaCss3Alt,
    FaReact,
    FaAngular,
    FaJava,
    SiSpringboot,
    SiVisualstudiocode,
    RiFlashlightLine,     // Azure Functions
    RiCloudLine,          // Azure Cloud (genérico)
    SiRabbitmq,
    FaDatabase,           // Cosmos DB
    SiPostgresql,
    SiMongodb,
    FaLaravel,
    FaGithub,
    SiCsharp,
    SiAzuredevops,
    SiDocker,
    FaHtml5,
    FaAws,
    SiDotnet,
    SiMysql,
    FaVuejs,
    FaNodeJs,
    FaJs,
    FaSass,
    FaPython,
    FaUbuntu,
    FaCss3Alt,
    FaReact,
    FaAngular,
    FaJava,
    SiSpringboot,
    SiVisualstudiocode,
    RiFlashlightLine,
    RiCloudLine,
    SiRabbitmq,
    FaDatabase,
    SiPostgresql,
    SiMongodb,
    FaLaravel,
    FaGithub,
  ];

  return (
    <Flex
      w="100%"
      position="relative"
      fontSize="6xl"
      transform="rotate(-30deg)"
      ml={-10}
      overflow="hidden"
    >
      <Flex>
        {icons.map((icon, i) => (
          <AnimatedIcon
            reactIcon={icons[Math.floor(Math.random() * icons.length)]}
            key={i}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default IconsLine;
